import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiLinks } from '@cutting/app.api-links';
import { TokenManagerService } from '@cutting/main/client/authentication/token-manager/token-manager.service';
import { FuseConfigService } from '@fuse/services/config.service';

import { LocalStorageManager } from '../helper/local-storage-manager.helper';

@Injectable()
export class LogoutService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private tokenManagerService: TokenManagerService,
    private fuseConfig: FuseConfigService
  ) {}

  logout(): Promise<void> {
    return new Promise((resolve, reject) => {
      const tokens = this.tokenManagerService.getTokens();

      if (tokens !== null) {
        this.http.get(ApiLinks.logout).subscribe(() => {
          const userIdLS = LocalStorageManager.regData;
          if (userIdLS) {
            LocalStorageManager.removeRegData();
          }

          LocalStorageManager.removeClient();
          this.router.navigate(['/client/auth/login'], {
            queryParams: userIdLS ? { user: userIdLS } : null,
          });

          this.fuseConfig.setConfig({
            layout: {
              navigation: 'none',
              toolbar: 'none',
              footer: 'none',
            },
          });

          resolve(undefined);
        }, reject);
      }
    });
  }
}
